var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M9.0804,0.5 C3.99767806,1.9633092 0.503544907,6.54859542 0.5,11.7599 C0.5,14.8735669 1.75694494,17.8597072 3.99432924,20.0614033 C6.23171355,22.2630994 9.26625916,23.5 12.4304,23.5 C17.3072826,23.4961869 21.6907955,20.5718386 23.5,16.1152 C22.412141,16.4307102 21.284122,16.5919664 20.15,16.5941 C13.5610565,16.5940451 8.21969383,11.3378376 8.2197,4.854 C8.22284842,3.36203336 8.51496109,1.88433082 9.0804,0.5 L9.0804,0.5 Z","id":"Path","fillRule":"nonzero"}))]);
}

Moon.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Moon;

Moon.default = Moon;
